import { render, staticRenderFns } from "./index-mock.vue?vue&type=template&id=176aed82&scoped=true"
import script from "./index-mock.vue?vue&type=script&lang=js"
export * from "./index-mock.vue?vue&type=script&lang=js"
import style0 from "./index-mock.vue?vue&type=style&index=0&id=176aed82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176aed82",
  null
  
)

export default component.exports